import { message } from 'antd';

import { updateCaveat } from '../../../HttpRequests/caveats';
import handleException from '../../../Core/Helpers/handleException';

export default (data) => async () => {
  
  try {

    await updateCaveat({ id: data.id, data });
    
    message.success("Caveat Updated");

    return true;

  } catch (error) {
    
    handleException(error);

    return false;

  }
}